import { lazyRouteComponent } from "@tanstack/react-router";
import { Target } from "lucide-react";

import type { PageDef } from "@/app/registry";

export interface LabSearch {
  /** Underlying symbol, e.g. NIFTY, RELIANCE. */
  underlying: string;
  /** ISO expiry date; absent means the nearest. */
  expiry?: string;
  /** Ready-made strategy key (iron_condor, bull_call_spread, ...). */
  template: string;
  /** A watched strategy to open (its legs replace the template's). */
  watch?: number;
}

export function parseLabSearch(s: Record<string, unknown>): LabSearch {
  const u = typeof s.underlying === "string" && /^[A-Za-z0-9&_-]{1,30}$/.test(s.underlying) ? s.underlying : "NIFTY";
  const e = typeof s.expiry === "string" && /^\d{4}-\d{2}-\d{2}$/.test(s.expiry) ? s.expiry : undefined;
  const t = typeof s.template === "string" && /^[a-z_]{1,40}$/.test(s.template) ? s.template : "iron_condor";
  const w = Number(s.watch);
  const watch = Number.isInteger(w) && w > 0 ? { watch: w } : {};
  return { underlying: u.toUpperCase(), ...(e ? { expiry: e } : {}), template: t, ...watch };
}

export const pages: PageDef[] = [
  {
    path: "/app/strategy-lab",
    proOnly: true,
    title: "Options Strategy Lab",
    component: lazyRouteComponent(() => import("./StrategyLabPage"), "StrategyLabPage"),
    nav: { label: "Options Strategy Lab", icon: Target, group: "Premium", order: 5 },
    validateSearch: parseLabSearch,
  },
];
